import '../../styles/style.css'

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@material-ui/core'
import * as React from 'react'
import { CSSTransition } from 'react-transition-group'

import { buttonsStyles } from '../../styles/ButtonsStyles'

interface Props {
    title: string,
    onCancel: () => void,
    onConfirm: (params?: any) => void,
    description: string
}

export const ConfirmDialog: React.FC<Props> = ({
    title, description, onCancel, onConfirm
}) => {
    const [open, setOpen] = React.useState(true)
    const btn = buttonsStyles()
    const handleClose = () => {
        setOpen(false)
    }

    return (
        <div>
            <CSSTransition
                in={open}
                timeout={300}
                classNames={{
                    enter: 'alert-enter',
                    enterActive: 'alert-enter-active',
                    exit: 'alert-exit',
                    exitActive: 'alert-exit-active'
                }}
                unmountOnExit>
                <Dialog
                    style={{
                        backdropFilter: 'blur(3px)',
                        backgroundColor: 'rgba(0,0,30,0.4)'
                    }}
                    open={open}
                    keepMounted
                    onClose={handleClose}>
                    <DialogTitle style={{ color: 'white' }}>{title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{ color: 'white' }}>
                            {description}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>

                        <Button className={btn.cancelButton} onClick={onCancel}>
                            Nej
                        </Button>
                        <Button className={btn.saveButton} onClick={onConfirm}>
                            Ja, helt sikker
                        </Button>
                    </DialogActions>
                </Dialog>
            </CSSTransition>
        </div>
    )
}
